import type { JSXElement, ParentProps } from "solid-js";
import "@/components/fs-components";

const Layout = (props: ParentProps): JSXElement => {
  return (
    <div>
      <div class="text-FsBaseText" attr:data-testid="featured-dealer-layout">
        {props.children}
      </div>
    </div>
  );
};

export default Layout;
